module.exports = __webpack_public_path__ + "img/1551432470.6ca50a4d.jpg";